import * as actionTypes from "../actions/actionTypes";
import { updateObject } from "../utility";

const initialState = {
  reviews: [],
  loading: false,
  limit: 5,
  leadsexhausted: false,
  lastDoc: null,
  writeReviewLoading: false,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.REVIEWS_CONTROLS:
      return updateObject(state, action.payload);
    default:
      return state;
  }
};
export default reducer;